import { LoadModelDetailsRow } from "@/components/dataPages/loadboard";
import { getLoadId } from "@/utils/load";
import { CurrencyText } from "@/components/common/text";
import * as React from "react";
import { ArrowTo } from "@/components/common/svgs";

export const LoadModalDetails = ({ load, quote }) => {
    const idToShow = load.externalLoadId || getLoadId(load.uniqueId);
    const rawBidAmount = quote && quote.replace(/,/g, "");

    return (
        <div className="flex flex-col gap-2 rounded-lg bg-[rgba(0,0,0,0.03)] p-3">
            <LoadModelDetailsRow label="Load ID:">{idToShow}</LoadModelDetailsRow>
            <LoadModelDetailsRow label="Lane:">
                <div className="flex items-center gap-2">
                    <span>
                        {load.itineraryStops[0]?.stopCity}, {load.itineraryStops[0]?.stopState}
                    </span>
                    <span className="text-cm-p-text-secondary">
                        <ArrowTo />
                    </span>{" "}
                    <span>
                        {load.itineraryStops[load.itineraryStops.length - 1]?.stopCity},{" "}
                        {load.itineraryStops[load.itineraryStops.length - 1]?.stopState}
                    </span>
                </div>
            </LoadModelDetailsRow>
            <LoadModelDetailsRow label="Distance:">
                {load.loadDistance ? `${Math.round(load.loadDistance)} miles` : " - "}
            </LoadModelDetailsRow>
            <LoadModelDetailsRow label="Trailer type:">{load.humanReadableEquipment || "-"}</LoadModelDetailsRow>
            {load.offerRate ? (
                <LoadModelDetailsRow label="Offer:">
                    <div className="flex flex-row gap-4 items-center">
                        <div>
                            <CurrencyText className="text-sm/[19px]" num={load.offerRate} round />
                        </div>
                        {load.rpm ? <div className="h-3 w-[1px] bg-cm-p-outline" /> : null}
                        {load.rpm ? (
                            <div>
                                <CurrencyText className="text-sm/[19px]" num={load.rpm} />
                            </div>
                        ) : null}
                    </div>
                </LoadModelDetailsRow>
            ) : null}
            {rawBidAmount ? (
                <LoadModelDetailsRow label="Your bid:">
                    <div className="flex flex-row gap-4 items-center">
                        <div>
                            <CurrencyText className="text-sm/[19px]" num={rawBidAmount} round />
                        </div>
                        {load.loadDistance ? <div className="h-3 w-[1px] bg-cm-p-outline" /> : null}
                        {load.loadDistance ? (
                            <div>
                                <CurrencyText className="text-sm/[19px]" num={rawBidAmount / load.loadDistance} round />
                            </div>
                        ) : null}
                    </div>
                </LoadModelDetailsRow>
            ) : null}
        </div>
    );
};
